/**
 * Grabación de audio.
 *
 * El blob local es CACHÉ. En la Fase 8, Supabase Storage será la copia durable.
 * Hasta entonces, la red de seguridad es la descarga manual al dispositivo
 * (Ajuste 3), obligatoria para baseline y checkpoints.
 */

import type { Id } from './ids.js';
import type { MetadatosSync } from './sincronizacion.js';

export const ETIQUETAS_GRABACION = [
  'baseline_w0',
  'checkpoint_w4',
  'checkpoint_w8',
  'checkpoint_w12',
  'practica_pronunciacion',
  'muestra_libre',
] as const;
export type EtiquetaGrabacion = (typeof ETIQUETAS_GRABACION)[number];

export const NOMBRE_ETIQUETA: Record<EtiquetaGrabacion, string> = {
  baseline_w0: 'Baseline W0',
  checkpoint_w4: 'Checkpoint W4',
  checkpoint_w8: 'Checkpoint W8',
  checkpoint_w12: 'Checkpoint W12',
  practica_pronunciacion: 'Práctica de pronunciación',
  muestra_libre: 'Muestra libre',
};

/**
 * Etiquetas cuya grabación DEBE poder descargarse al dispositivo (Ajuste 3).
 * Son las que sostienen la comparación longitudinal del programa: perderlas
 * no se puede deshacer.
 */
export const ETIQUETAS_CRITICAS: EtiquetaGrabacion[] = [
  'baseline_w0',
  'checkpoint_w4',
  'checkpoint_w8',
  'checkpoint_w12',
];

export interface Grabacion extends MetadatosSync {
  id: Id;
  sesionId?: Id;
  /**
   * Paso al que pertenece, cuando la grabación salió de uno.
   *
   * Es lo que permite saber si un paso que exige muestra ya la tiene, y por
   * tanto si puede darse por completado.
   */
  stepKey?: string;
  etiqueta: EtiquetaGrabacion;
  /** Nombre editable por el usuario. */
  nombre: string;
  segundos: number;
  mimeType: string;
  /** Caché local. Se omite al exportar: el JSON no lleva blobs (CA-4.9). */
  blobLocal?: Blob;
  /** Copia durable en la nube. FASE 8. */
  storagePath?: string;
  subida: boolean;
  /** El usuario ya guardó una copia en su dispositivo (Ajuste 3). */
  descargadaManualmente: boolean;
  creadoEn: string;
}

export function esCritica(grabacion: Grabacion): boolean {
  return ETIQUETAS_CRITICAS.includes(grabacion.etiqueta);
}
